import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const checkEmailRequestStatus = async (projectKey: string) =>
	fetchJson(`/rest/servicedesk/1/servicedesk/${projectKey}/incomingemail`);
